import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts, glyphs } from "../../../Styles";
import { NewButton, NewInput, PrimaryPopover } from "../..";
import { ButtonTypes, CreateNewFieldStyle, CreateNewFieldType, NewFieldStyles, NewFieldTypes, NewInputHandles } from "../../../Definitions";

interface feedSkipPopoverProps {
  header?: string
  defaultValue?: number
  focusView?: boolean
  onChange?: (value: number) => void
  fieldOverrides?: {
    fieldHeight?: string
    fieldStyle?: NewFieldStyles,
    fieldType?: NewFieldTypes,
    fieldWidth?: string
  }
}

export default function FeedSkipPopover({ header, defaultValue, focusView=false, onChange, fieldOverrides }:feedSkipPopoverProps) {
  const { t } = useTranslation()
  const inputRef = useRef<NewInputHandles>(null);

  const [shiftDown, setShiftDown] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Shift") setShiftDown(true);
    };
    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.key === "Shift") setShiftDown(false);
    };
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  const decrease = () => {
    const step = shiftDown ? 10 : 1;
    if (onChange) onChange(Math.max((defaultValue ?? 0) - step, -99));
  };

  const increase = () => {
    const step = shiftDown ? 10 : 1;
    if (onChange) onChange(Math.min((defaultValue ?? 0) + step, 100));
  };
  
  const reset = () => {
    if (onChange) onChange(0);
  };

  const feedCorrectionPopoverStyle = { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
  
  const { fontColor } = useMemo(() => {
    var _Style = CreateNewFieldStyle(fieldOverrides?.fieldStyle)
    return _Style
  }, [fieldOverrides?.fieldStyle])

  const { containerPaddingRight } = useMemo(() => {
    var _Style = CreateNewFieldType(fieldOverrides?.fieldType)
    return _Style
  }, [fieldOverrides?.fieldType])

  return ( 
    <div style={{width: fieldOverrides&&fieldOverrides.fieldWidth ? fieldOverrides.fieldWidth : "100%"}}>
      {header && <p style={{ ...fonts.header, ...(focusView ? fonts.fontsize3 : fonts.fontSize4), color: colors.greyPrimary, padding: "0px 0px 2px 10px"}}>{header}</p>}
      <PrimaryPopover 
        content={
          <div style={{ position: "relative" }}>
            <NewInput
              ref={inputRef}
              onChange={(e) => onChange ? onChange(Number(e)) : undefined}
              fieldOverrides={{
                fieldStyle: fieldOverrides?.fieldStyle ? fieldOverrides.fieldStyle : NewFieldStyles.greyTertiary,
                fieldType: fieldOverrides?.fieldType ? fieldOverrides.fieldType : NewFieldTypes.tableHeaderCell,
                fieldWidth: fieldOverrides?.fieldWidth ? fieldOverrides.fieldWidth : "100%",
                showNumberSpinners: false,
                focus_view: focusView
              }}
              valueOverrides={{
                defaultValue: defaultValue ? defaultValue : 0,
                valueType: "number",
                minValueNumber: -99,
                maxValueNumber: 100
              }}
            />
            <div style={{ position: "absolute", backgroundColor: colors.transparent, width: "fit-content", top: "50%", right: containerPaddingRight, transform: "translateY(-50%)", ...( focusView ? fonts.fontSize3 : fonts.fontSize4), ...fonts.paragraph, lineHeight: "0", pointerEvents: "none", color: fontColor}}>Hours</div>
          </div>
        } 
        overrides={{
          contentContainer: {width: "100%"}
        }}
        createPopoverPortal={false}
        popoverHeader={ focusView ? "" : t("feed.feedCorrection.feedSkip", {defaultValue: "Feed Skip"})} 
        popoverContent={
          focusView ? undefined :
          <div style={{display: "grid", gridTemplateColumns: "repeat(2, 65px)", gridTemplateRows: "repeat(2, 40px)"}}>
            <div style={{gridArea: "1/1/2/2", ...feedCorrectionPopoverStyle, borderRight: "1px solid "+colors.greyDarkSecondary}}>
              <NewButton content={""} buttonType={ButtonTypes.glyphButton} startEnhancer={<glyphs.Minus/>} onClick={decrease} overrides={{baseStyles: {width: "100%", height: "100%"}}}/> 
            </div>
            <div style={{gridArea: "1/2/2/3", ...feedCorrectionPopoverStyle, borderLeft: "1px solid "+colors.greyDarkSecondary}}>
              <NewButton content={""} buttonType={ButtonTypes.glyphButton} startEnhancer={<glyphs.Add/>} onClick={increase} overrides={{baseStyles: {width: "100%", height: "100%"}}}/> 
            </div>
            <div style={{gridArea: "2/1/3/3", ...feedCorrectionPopoverStyle, borderTop: "2px solid "+colors.greyDarkSecondary, color: colors.greyLightTertiary, ...fonts.fontSize3, ...fonts.header}}>
              <NewButton content={t("feed.feedCorrection.reset", {defaultValue: "reset"})} buttonType={ButtonTypes.textButton} onClick={reset} overrides={{baseStyles: {width: "100%", height: "100%", gridTemplateColumns: "1fr"}}}/> 
            </div>
          </div>
        }
      /> 
    </div> 
  )
}